import { BlockToComponentMap } from 'app/features/shared/blocks'
import { ArticleGridBlockType, ArticleGridComponent } from './article-grid-block'
import { FeaturedArticleBlockType, FeaturedArticleComponent } from './featured-article-block'
import { WriteForUsBlockType, WriteForUsComponent } from './write-for-us-block'

export const getArticleBlockMappings = (): BlockToComponentMap => ({
  [ArticleGridBlockType]: { Component: ArticleGridComponent },
  [FeaturedArticleBlockType]: { Component: FeaturedArticleComponent },
  [WriteForUsBlockType]: { Component: WriteForUsComponent },
})
